import { format } from 'date-fns'

import PreHero from './pre-hero'

const Hero = ({ publishedDate, title }) => (
  <div>
    <PreHero type="Interview" />
    <div className="text-center mt-10 lg:mt-24">
      {publishedDate && (
        <p className="text-sm uppercase tracking-[4px] font-aeonik">
          {format(new Date(publishedDate), "MMMM do, yyyy")}
        </p>
      )}
      <h1 className="text-4xl lg:text-5xl mt-6 lg:mt-8 font-aeonik">{title}</h1>
    </div>
  </div>
);

export default Hero;